var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn btn-outline cerrar-sesion box-center btn-cerrar",on:{"click":function($event){_vm.$utils.logout(); _vm.$router.push('/')}}},[_c('img',{attrs:{"height":"15","src":require("@/assets/icons/cerrar-sesion.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }